// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"tX-z","inlineTitle":"uX-z","sponsoredAdsWrapper":"vX-z","marketplaceRecosWrapper":"wX-z"};